import { IPaymentMethod } from './types';

export const CASH_ACCOUNT_IDENTIFIER = 'CASH';
export const FREE_ORDER_ACCOUNT_IDENTIFIER = 'FREE_ORDER';
export const PAYPAL_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  paypal: true,
  fdAccountId: 'PAYPAL',
  accountIdentifier: 'PAYPAL',
  chaseProfileId: null,
  credit: null,
  prepaid: null,
  paypalIdentifier: null,
  ideal: null,
  sodexo: null,
  chequeGourmet: null,
  transient: true,
};

export const BLIK_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  paypal: null,
  fdAccountId: 'BLIK',
  accountIdentifier: 'BLIK',
  paymentMethodBrand: 'BLIK',
  blik: true,
  chaseProfileId: null,
  credit: null,
  prepaid: null,
  paypalIdentifier: null,
  ideal: null,
  sodexo: null,
  chequeGourmet: null,
};

export const SODEXO_VOUCHER_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  sodexo: true,
  fdAccountId: 'CASH',
  accountIdentifier: 'SODEXO_VOUCHER',
  paymentMethodBrand: 'SODEXO_VOUCHER',
  chaseProfileId: null,
  credit: null,
  prepaid: null,
  paypalIdentifier: null,
  ideal: null,
  paypal: false,
  chequeGourmet: null,
};

export const CHEQUE_GOURMET_VOUCHER_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  chequeGourmet: true,
  fdAccountId: 'CASH',
  accountIdentifier: 'CHEQUE_GOURMET_VOUCHER',
  paymentMethodBrand: 'CHEQUE_GOURMET_VOUCHER',
  chaseProfileId: null,
  credit: null,
  prepaid: null,
  paypalIdentifier: null,
  ideal: null,
  paypal: false,
  sodexo: null,
};

export const SODEXO_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  sodexo: true,
  fdAccountId: 'CASH',
  accountIdentifier: 'SODEXO',
  paymentMethodBrand: 'SODEXO',
  chaseProfileId: null,
  credit: null,
  prepaid: null,
  paypalIdentifier: null,
  ideal: null,
  paypal: false,
  chequeGourmet: null,
  transient: true,
};

export const CHEQUE_GOURMET_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  chequeGourmet: true,
  fdAccountId: 'CASH',
  accountIdentifier: 'CHEQUE_GOURMET',
  paymentMethodBrand: 'CHEQUE_GOURMET',
  chaseProfileId: null,
  credit: null,
  prepaid: null,
  paypalIdentifier: null,
  ideal: null,
  paypal: false,
  sodexo: null,
  transient: true,
};

export const PAYMENT_ON_DELIVERY_CARD_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  chequeGourmet: null,
  fdAccountId: 'CASH',
  accountIdentifier: 'PAYMENT_ON_DELIVERY_CARD',
  paymentMethodBrand: 'PAYMENT_ON_DELIVERY_CARD',
  chaseProfileId: null,
  credit: null,
  prepaid: null,
  paypalIdentifier: null,
  ideal: null,
  paypal: false,
  sodexo: null,
  paymentOnDeliveryCard: true,
};

export const BIZUM_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  bizum: true,
  fdAccountId: 'BIZUM',
  accountIdentifier: 'BIZUM',
  paymentMethodBrand: 'BIZUM',
  chaseProfileId: null,
  credit: null,
  prepaid: null,
  paypalIdentifier: null,
  ideal: null,
  paypal: false,
  sodexo: null,
  chequeGourmet: false,
  transient: true,
};
